import Axios from '../Axios'

const payBack = {
  create(data) {
    return Axios.post('/paybacks', data)
  },
  read(limit = 10, page = 1, search) {
    return Axios.get('/paybacks?limit=' + limit + '&page=' + page + search)
  },
  readOne(id) {
    return Axios.get('/paybacks/' + id)
  },
  update(id, data) {
    return Axios.put('/paybacks/' + id, data)
  },
}

export default payBack
